<router-outlet></router-outlet>
<app-sz-2020-logo></app-sz-2020-logo>
<app-ginop-footer></app-ginop-footer>
